export enum ToastTypeEnum {
  DARK = 'dark',
  ERROR = 'error',
  INFO = 'info',
  SUCCESS = 'success',
  WARNING = 'warn',
}
